import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import {CTX_TOAST_ERRORS} from "../../models/api-context-const";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const messages = inject(MessageService);
    const toast = req.context.get(CTX_TOAST_ERRORS);

    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            if (toast) {
                const detail = err.error?.statusMessage ?? err.error?.message ?? err.message ?? 'Server error';
                messages.add({ severity: 'error', summary: 'Errore', detail });
            }
            return throwError(() => err);
        }),
    );
};
